// MotoParts — Pieza a Medida: el cliente adjunta una foto de referencia
// (opcional) y cuenta su idea; el archivo se sube solo al enviar el
// formulario, como propiedad de línea del pedido (multipart nativo de
// Shopify, sin apps).

function mtInitPiezaMedida() {
  document.querySelectorAll('[data-mt-pieza-medida]').forEach(function (raiz) {
    var input = raiz.querySelector('[data-mt-pm-file]');
    var dropzone = raiz.querySelector('[data-mt-pm-dropzone]');
    var nombreArchivo = raiz.querySelector('[data-mt-pm-nombre-archivo]');
    var estado = raiz.querySelector('[data-mt-pm-estado]');
    var form = raiz.querySelector('[data-mt-pm-form]');
    var btnEnviar = raiz.querySelector('[data-mt-pm-enviar]');
    if (!input || !form) return;

    var limiteMb = parseFloat(raiz.dataset.mtPmLimiteMb || '20');

    function procesarArchivo(file) {
      if (!file) return;
      if (file.type.indexOf('image/') !== 0) {
        estado.textContent = 'Ese archivo no es una foto. Elige una imagen (jpg, png...).';
        estado.classList.add('mt-pm__estado--error');
        return;
      }
      if (file.size > limiteMb * 1024 * 1024) {
        estado.textContent = 'La foto pesa demasiado (máximo ' + limiteMb + ' MB).';
        estado.classList.add('mt-pm__estado--error');
        return;
      }

      estado.classList.remove('mt-pm__estado--error');
      estado.textContent = 'Foto adjuntada.';
      nombreArchivo.textContent = file.name;
    }

    input.addEventListener('change', function () {
      procesarArchivo(input.files && input.files[0]);
    });

    if (dropzone) {
      dropzone.addEventListener('click', function () { input.click(); });
      dropzone.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          input.click();
        }
      });
      ['dragover', 'dragenter'].forEach(function (evt) {
        dropzone.addEventListener(evt, function (e) {
          e.preventDefault();
          dropzone.classList.add('mt-pm__dropzone--sobre');
        });
      });
      ['dragleave', 'dragend'].forEach(function (evt) {
        dropzone.addEventListener(evt, function () {
          dropzone.classList.remove('mt-pm__dropzone--sobre');
        });
      });
      dropzone.addEventListener('drop', function (e) {
        e.preventDefault();
        dropzone.classList.remove('mt-pm__dropzone--sobre');
        var file = e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0];
        if (!file) return;
        try {
          var dt = new DataTransfer();
          dt.items.add(file);
          input.files = dt.files;
        } catch (err) { /* Safari antiguo: seguimos solo con el input nativo */ }
        procesarArchivo(file);
      });
    }

    form.addEventListener('submit', function () {
      if (btnEnviar) {
        btnEnviar.disabled = true;
        btnEnviar.textContent = 'Enviando…';
      }
    });
  });
}

document.addEventListener('DOMContentLoaded', mtInitPiezaMedida);
